import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {resetPasswordError, resetPasswordSuccess} from "features/pages/account/reset-password/reducer";


export function* resetPasswordSaga({payload}) {
    try {
        yield call([api, api.resetPassword], payload.password, payload.token);
        yield put(resetPasswordSuccess())
    } catch (e) {
        yield put(resetPasswordError(getErrorFromMessage(e)))
    }
}